import {gql,TypedDocumentNode} from '@apollo/client';

type StageBase = {
    description: string,
    id: string,
    order: number,
    stageStatus: 'PENDING' | 'IN_PROGRESS' | 'APPROVED' | 'REJECTED',
    title: string,
    updatedAt: Date,
}

export type NoActionStage = StageBase & {
    files?: undefined,
    rejectionMessage?: undefined,
    stageType: 'NO_ACTION',
    waitTime: number,
}

export type ApprovalStage = StageBase & {
    files?: undefined,
    rejectionMessage: string,
    stageType: 'APPROVAL',
    waitTime: number,
}

export type UploadStageFile = {fileId: string | undefined, id: string, title: string, requiredFileType: 'pdf' | 'image'}

export type UploadStage = StageBase & {
    files: UploadStageFile[],
    rejectionMessage?: undefined,
    stageType: 'UPLOAD',
    waitTime?: undefined,
}

export type Stage = NoActionStage | ApprovalStage | UploadStage

interface Result {
    showMyApplicationDetails: {
        applicationStages: Stage[],
        id: string,
        package: {
            code: string,
        },
        profile: {
            agreementSignedAt: Date,
            company: string
        }
        status: 'IN_PROGRESS' | 'APPROVED' | 'REJECTED',
        updatedAt: Date,
    }
}

export const GET_MY_APPLICATION_DETAILS: TypedDocumentNode<Result> = gql`
    query GetMyApplicationDetails {
        showMyApplicationDetails {
            applicationStages {
                description
                files {
                    fileId
                    id
                    title
                    requiredFileType
                }
                id
                order
                rejectionMessage
                stageStatus
                stageType
                title
                updatedAt
                waitTime
            }
            id
            package {
                code
            }
            profile {
                agreementSignedAt
                company
            }
            status
            updatedAt
        }
    }       
`
